const typeParams = {
  0: '取货点',
  1: '送货点',
  2: '取货点+送货点'
}

export const businessModelType = [
  {
    label: '自营',
    value: 'PROPRIETARY',
  },
  {
    label: '加盟',
    value: 'JOIN',
  },
  {
    label: '经销商',
    value: 'DEALERS',
  },
]
export const typeList = [
  {
    label: '取货点',
    value: 'SHIPPING',
  },
  {
    label: '送货点',
    value: 'RECEIVING',
  },
  {
    label: '取货点+送货点',
    value: 'SHIPPING_RECEIVING',
  }
]

export const STATIONTYPELIST = [
  {
    label: '取货点',
    value: 0,
  },
  {
    label: '送货点',
    value: 1,
  },
  {
    label: '取货点+送货点',
    value: 2,
  }
]

export const STATUSPARAMS = {
  0: '停用',
  1: '启用',
}

export const statusList = [
  {
    label: '停用',
    value: 'DISABLED'
  },
  {
    label: '启用',
    value: 'ENABLED'
  }
]

export const STATUSLIST = [
  {
    label: '启用',
    value: 1
  },
  {
    label: '停用',
    value: 0
  },
]

export const STATUS = {
  0: 'DISABLED',
  1: 'ENABLED'
}
export const StationTypes = {
  0: 'SHIPPING',
  1: 'RECEIVING',
  2: 'SHIPPING_RECEIVING',
};
export const BizTypeMap = {
  TRANSPORT: 'TRANSPORT',
  TRANSPORT_WAREHOUSE: 'TRANSPORT_WAREHOUSE'
}

export const COLUMNS = [
  {
    title: "站点名称",
    dataIndex: "stationName",
    scopedSlots: { customRender: "stationName" },
    width: 240,
  },
  {
    title: "站点编码",
    dataIndex: "stationCode",
    width: 180,
    ellipsis: true,
  },
  {
    title: "自定义编码",
    dataIndex: "customerStationCode",
    width: 160,
    ellipsis: true,
  },
  {
    title: "联系人姓名",
    dataIndex: "contacts",
    width: 160,
    ellipsis: true,
  },
  {
    title: "联系人电话",
    dataIndex: "telPhone",
    width: 160,
  },
  {
    title: "详细地址",
    dataIndex: "address",
    customRender: (text, record) => record.poiExt.address,
    width: 240,
  },
  {
    title: "线路标识",
    dataIndex: "preLineIdent",
    width: 200,
    ellipsis: true,
  },
  {
    title: "服务商",
    dataIndex: "ownerTenantName",
    width: 160,
    ellipsis: true,
  },
  {
    title: "类型",
    dataIndex: "stationType",
    width: 120,
    customRender: (text) => typeParams[text]
  },
  {
    title: "状态",
    dataIndex: "status",
    width: 120,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 220,
    fixed: 'right'
  }
]

function checkMobile(val) {
  const telReg =/^[0-9;-]*$/g
  if (telReg.test(val)) {
    return true;
  }
  return false;
}

export const CREATERULE = {
  contacts: [
    { required: true, message: '请输入联系人姓名', trigger: 'change' },
  ],
  stationName: [
    { required: true, message: '请输入站点名称', trigger: 'change' },
  ],
  telPhone: [
    { required: true, message: '联系人电话', trigger: 'change' },
    {
      validator: (rules, value, callback) => {
        const flag = checkMobile(value)
        if (!flag) {
          callback(new Error('只能输入数字和;和-'));
        }
        callback()
      },
      trigger: "change"
    }
  ],
  stationType: [
    { required: true, message: '请选择地址类型', trigger: 'change' },
  ],
  status: [
    { required: true, message: '请选择站点状态', trigger: 'change' },
  ],
  ownerTenantId: [
    { required: true, message: '请选择服务商', trigger: 'change' },
  ],
  address: [
    { required: true, message: '请选择详细地址', trigger: 'change' },
  ]
}

// 列表搜索配置
export const SearchFiled = [
  {
    label: '服务商',
    name: 'customerCode',
    type: 'carrier',
    prop: {
      isDefaultSelect: true
    }
  },
  {
    label: '站点名称',
    name: 'stationNameLike',
    type: 'input',
    prop: {
      placeholder: '请输入地址名称或者关键字查询',
      maxLength: 100
    },
  },
  {
    label: '详细地址',
    name: 'addressLike',
    type: 'input',
    prop: {
      placeholder: '请输入地址名称或者关键字查询',
      maxLength: 100
    },
  },
  {
    label: '类型',
    name: 'stationType',
    type: 'select',
    prop: {
      placeholder: '请选择地址类型',
      allowClear: true,
      options: typeList
    },
  },
  {
    label: '状态',
    name: 'status',
    type: 'select',
    prop: {
      placeholder: '请选择地址状态',
      allowClear: true,
      options: statusList
    },
  },
  {
    label: '站点编码',
    name: 'customerOrStationCode',
    // name: 'stationCodeLike',
    type: 'input',
    prop: {
      placeholder: '请输入站点编码/自定义编码',
      maxLength: 30,
    },
  },
]